import React from "react";
import { shallowEqual } from "react-redux";
import * as Styles from "./styles/Valuation";
import { useTradeInCsl } from "../../../../csl/tradeInCslUtils";
import { useTradeInAemSelector } from "../../../../redux/store";
import { useTradeInAemLabel, useTradeInAemOptionalLabel } from "../../../../utils/labels";
import { formatPrice } from "../../../../../common-deprecated/Globalize";

const Valuation = (): JSX.Element => {
    const csl = useTradeInCsl();
    const vehicleValue = useTradeInAemSelector(csl.vehicleValueSelector, shallowEqual);
    const cultureName = useTradeInAemSelector((state) => state.commonSettings.culture.name);
    const [titleLabel, loanEstimationLabel, financeLabel, loanDescriptionLabel] = useTradeInAemLabel([
        "tradeInAemValuationTitle",
        "tradeInAemOutstandingLoanEstimation",
        "tradeInAemOutstandingLoanFinance",
        "tradeInAemOutstandingLoanDescription",
    ]);
    const disclaimerLabel = useTradeInAemOptionalLabel("tradeInAemDisclaimer");
    const hasDisclaimer = !!disclaimerLabel;

    const originalEstimationFormatted = formatPrice(
        vehicleValue?.outstandingLoan?.originalEstimation || 0,
        cultureName,
    );
    const outstandingLoanFormatted = formatPrice(vehicleValue?.outstandingLoan?.outstandingLoan || 0, cultureName);
    const vehicleValueFormatted = formatPrice(vehicleValue?.value || 0, cultureName);

    return !vehicleValue?.outstandingLoan ? (
        <Styles.Valuation>
            <Styles.ValuationLabel>{titleLabel}</Styles.ValuationLabel>
            <Styles.ValuationValue>
                <span dangerouslySetInnerHTML={{ __html: vehicleValueFormatted }} />
                {hasDisclaimer && <sup> *</sup>}
            </Styles.ValuationValue>
        </Styles.Valuation>
    ) : (
        <Styles.ValuationGrid>
            <Styles.ValuationItem>
                <Styles.ValuationLabel light>{loanEstimationLabel}</Styles.ValuationLabel>
                <Styles.ValuationValue light>
                    <span dangerouslySetInnerHTML={{ __html: originalEstimationFormatted }} />
                </Styles.ValuationValue>
            </Styles.ValuationItem>
            <Styles.ValuationItem>
                <Styles.ValuationLabel>{financeLabel}</Styles.ValuationLabel>
                <Styles.ValuationValue>
                    <span dangerouslySetInnerHTML={{ __html: outstandingLoanFormatted }} />
                </Styles.ValuationValue>
            </Styles.ValuationItem>
            <Styles.ValuationItem fullWidth>
                <Styles.ValuationLabel>{loanDescriptionLabel}</Styles.ValuationLabel>
                <Styles.ValuationValue>
                    <span dangerouslySetInnerHTML={{ __html: vehicleValueFormatted }} />
                    {hasDisclaimer && <sup> *</sup>}
                </Styles.ValuationValue>
            </Styles.ValuationItem>
        </Styles.ValuationGrid>
    );
};
export default Valuation;
